module.exports = __webpack_public_path__ + "static/media/icon-menu.4804f9ec.svg";